import request from '../utils/request'

let clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID || '';

if (window.innerWidth < 768) {
  clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID_MOBILE || '';
}

// 用户登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: { ...data, clientId },
    encrypt: true
  })
}

// 获取验证码
export function getCode(params) {
  return request({
    url: '/resource/sms/code',
    method: 'get',
    params
  })
}

// 获取租户列表
export function getTenantList(params) {
  return request({
    url: '/auth/tenant/list',
    method: 'get',
    params
  })
}

/**
 * 图片验证码
 * @returns resp
 */
export function captchaImage(params) {
  // return requestClient.get<CaptchaResponse>('/auth/code');
  return request({
    url: '/auth/code',
    method: 'get',
    params
  })
}

/**
 * 获取行业字典数据
 */
export function getDict(dictType) {
  // return requestClient.get('/auth/company/dict', {
  //   params: {
  //     dictType: 'sys_company_industry'
  //   }
  // });
  return request({
    url: '/auth/company/dict',
    method: 'get',
    params: {
      dictType
    }
  })
}


/**
 * 注册用户
 */
export function register(data) {
  return request({
    url: '/auth/registerNew',
    method: 'post',
    data: { ...data, clientId },
    encrypt: true
  })
}

/**
 * 获取用户信息
 */
export function getProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get',
  })
}


/**
 * 手机号修改密码
 */
export function retrievePassword(data) {
  return request({
    url: '/auth/retrievePassword',
    method: 'post',
    data: { ...data },
    encrypt: true
  })
}


/**
 * 绑定第三方账号
 */
export function authBinding() {
  return request({
    url: `/auth/binding/wechat_mp`,
    method: 'get',
    params: {
      domain: window.location.host,
      tenantId: '000000',
    },
  })
}

/**
 *获取二维码扫描结果
 */
export function getScanResult(uuid, signal) {
  return request({
    url: `/auth/scanCodeRes`,
    method: 'get',
    params: { uuid },
    signal
  })
}


// 获取wx跳转地址
export function getWxJumpUrl() {
  return request({
    url: `/auth/social/getCallbackUrl`,
    method: 'get',
    params: {},
  })
}

export function getWxOpenId(state) {
  return request({
    url: `/auth/social/getOpenId`,
    method: 'get',
    params: { state },
  })
}




// 用户登出
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

// 获取租户信息
export function getTenantInfo() {
  return request({
    url: '/system/tenant/getTenantInfo',
    method: 'get',
  })
}

// 获取会员版/AI算力点购买列表
export function selectListFree(params = { pageNum: 1, pageSize: 10 }) {
  return request({
    url: '/sale/salePackage/selectListFree',
    method: 'get',
    params
  })
}


